module.exports = "/static/assets/7fcbbbf879415d8bd7703b7560c08c28.png";